import { useEffect, useState, useCallback, Suspense, FC } from 'react';
import Loader, { LOADER_TYPE } from '@mindtickle/loader';

import { useUserAuth } from '~/components/Auth';
import { LoadRemote } from '~/components/DynamicRemote';

import { fetchProfileCompleteStatus } from './api';
import { StyledModal } from './style';
import { DYNAMIC_REMOTES } from '~/config/app.constants';

const MODAL_BODY_STYLE = {
  padding: '0px',
  borderRadius: '8px',
  height: 'calc(100vh - 48px)',
};

const IncompleteProfileModal: FC = () => {
  const { sessionId, id: userId } = useUserAuth();
  const [isProfileInComplete, updateProfileCompleteStatus] = useState<boolean | undefined>(
    undefined
  );

  useEffect(() => {
    fetchProfileCompleteStatus({ sessionId, userId }).then(response => {
      updateProfileCompleteStatus(!response);
    });
  }, [sessionId, userId]);

  const closeModal = useCallback(() => {
    window.location?.reload();
  }, []);

  return (
    <StyledModal
      visible={isProfileInComplete}
      width={1024}
      closable={false}
      bodyStyle={MODAL_BODY_STYLE}
      destroyOnClose
      className="fullpage-modal"
    >
      <Suspense fallback={<span />}>
        <LoadRemote
          remote={DYNAMIC_REMOTES.EDIT_PROFILE}
          loader={<Loader type={LOADER_TYPE.Full} size="sizeBig" />}
          lazy={false}
          onSuccess={closeModal}
          mandatoryToComplete={true}
        />
      </Suspense>
    </StyledModal>
  );
};

export default IncompleteProfileModal;
